import { useSelector } from 'react-redux';
import { HAS_LAUNCHED_STATES, NA } from 'modules/experiments/constants';
import { CellAlignTypes, ExperimentSummaryRowDataProps } from 'modules/experiments/types';
import {
  getExperimentHasWinner,
  getExperimentStateStatus,
} from 'modules/experiments/ducks/selectors';
import {
  getCellDisplayType,
  CELL_DISPLAY_TYPE,
  calculateSafeRatePercentage,
} from 'modules/experiments/utils';
import { colors } from 'ui/theme';
import { RowCell } from './RowCell';
import { PrimaryContent, SecondaryContent } from './Styled';

export const WinningCriteriaRateCell = ({ row }: ExperimentSummaryRowDataProps) => {
  const state = useSelector(getExperimentStateStatus);
  const experimentHasWinner = useSelector(getExperimentHasWinner);
  const cellDisplayType = getCellDisplayType(state, experimentHasWinner);
  const isMetricsAvailableForCalculations = row.sends && row.experimentWinningCriteria;

  // Metric Calculations
  const { rate: variantRate, percentage: variantPercentage } = calculateSafeRatePercentage({
    count: row.experimentWinningCriteria,
    total: row.sends || 0,
  });
  const { rate: controlRate } = calculateSafeRatePercentage({
    count: row.controlExperimentWinningCriteria,
    total: row.controlExperimentSends || 0,
  });

  let styledTextColor = colors.textPrimary;
  if (!row.control) {
    styledTextColor = variantRate > controlRate ? colors.green100 : colors.red100;
  }

  if (!isMetricsAvailableForCalculations || cellDisplayType === CELL_DISPLAY_TYPE.NA) {
    if (HAS_LAUNCHED_STATES.includes(state)) {
      return (
        <RowCell
          isWinner={row.winner.toString()}
          dataTestId={`metric-rate-cell-forced-zero-${row.variantTemplateID}`}
          primaryText={'0'}
          align={CellAlignTypes.flexEnd}
        />
      );
    }
    return (
      <RowCell
        isWinner={row.winner.toString()}
        dataTestId={`metric-rate-cell-na-${row.variantTemplateID}`}
        primaryText={NA}
        align={CellAlignTypes.flexEnd}
      />
    );
  }

  return (
    <RowCell
      isWinner={row.winner.toString()}
      dataTestId={`metric-rate-cell-variant-${row.variantTemplateID}`}
      secondaryText={row.experimentWinningCriteria}
      align={CellAlignTypes.flexEnd}
    >
      <PrimaryContent
        data-test={`metric-rate-cell-primary-text-${row.variantTemplateID}`}
        color={styledTextColor}
      >
        {variantPercentage}
      </PrimaryContent>
      <SecondaryContent data-test={`metric-rate-cell-secondary-text-${row.variantTemplateID}`}>
        {row.experimentWinningCriteria}
      </SecondaryContent>
    </RowCell>
  );
};
